var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ais-state-results", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ results: { hits } }) {
              return _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: hits.length === 0,
                      expression: "hits.length === 0",
                    },
                  ],
                },
                [
                  _c("ais-current-refinements", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({}) {
                            return [
                              _c(
                                "article",
                                { staticClass: "card roomy" },
                                [
                                  _c("font-awesome-icon", {
                                    staticStyle: {
                                      "--fa-secondary-opacity": "1",
                                      "--fa-secondary-color":
                                        "var(--fa-yellow)",
                                    },
                                    attrs: {
                                      icon: _vm.$v6.duotone.faFaceThinking,
                                      size: "4x",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("h1", { staticClass: "margin-y-2xs" }, [
                                    _vm._v("No Icons Found"),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "size-lg" }, [
                                    _vm._v(
                                      "There are no icons that match your current filters. Try removing some of them to get better results."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.clearFilters()
                                        },
                                      },
                                    },
                                    [_vm._v("Clear All Filters + Start Over")]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("icons-supplemental-actions", {
                                attrs: { version: _vm.version },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              )
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }